<template>
  <div>
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} Form</div>
      <router-link class="btn-blue" to="feedback-forms">Form Lists</router-link>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-4">
          <div class="input-material">
            <input
              @focus="onFocusHandler"
              :type="'text'"
              :name="'form_name'"
              :id="'form_name'"
              v-validate="'required|alpha_spaces'"
              v-model="fieldvalue"
              placeholder="."
            />
            <label>Form Name</label>
            <p class="error_message">
              <span v-if="submitted && errors.has('form_name')">{{ errors.first(`${'form_name'}`) }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="input-material-textarea">
            <textarea
              @focus="onFocusHandler"
              :type="'text'"
              :name="'form_description'"
              :id="'form_description'"
              v-validate="'required'"
              v-model="form_description"
              placeholder="."
            />
            <label>Form Description</label>
            <p class="error_message">
              <span
                v-if="submitted && errors.has('form_description')"
              >{{ errors.first(`form_description`) }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-4 align-self-center">
          <div class="d-flex align-items-center justify-content-end mb-2">
            <label class="mr-2 mb-0">Active</label>
            <b-form-checkbox 
            v-model="form_is_active"
             class="j-checkbox ml-2 pb-0" 
            >
            </b-form-checkbox>
          </div>
        </div>

        <div
          class="col-8 mb-3 pl-0"
          v-for="(formField, formFieldIndex) in formFieldList"
          :key="formFieldIndex"
        >
          <div class="row  mx-0 ">
            <div class="col-11 aling-self-center">
              <div class="row">
                <div class="col-lg-4">
                  <div class="input-material">
                    <input
                      type="text"
                      step="any"
                      v-model="formField.fieldvalue"
                      name="form_field"
                      id="form_field"
                      v-validate="'required'"
                      placeholder="."
                    />
                    <label>Form Field</label>
                    <p class="error_message">
                      <span
                        v-if="submitted && formField.fieldvalue.length == 0"
                      >{{ errors.first(`${'form_field'}`) }}</span>
                    </p>
                  </div>
                </div>

                <div class="col-lg-4">
                  <multiselect
                    v-model="formField.type"
                    :options="['text', 'textarea', 'number','checkbox','rating']"
                    placeholder="Type"
                    :allowEmpty="false"
                    :showLabels="false"
                    name="form_type"
                    id="form_type"
                  ></multiselect>
                  <p class="error_message">
                    <span v-if="submitted && formField.type.length == 0">Please Select Type.</span>
                  </p>
                </div>

                <div class="col-lg-4">
                  <multiselect
                    v-model="formField.priority"
                    :options="['Compulsary', 'Optional']"
                    placeholder="Select Priority"
                    :allowEmpty="false"
                    :showLabels="false"
                    name="form_priority"
                    id="form_priority"
                  ></multiselect>
                  <p class="error_message">
                    <span v-if="submitted && formField.priority.length == 0">Please select priority.</span>
                  </p>
                </div>

                <div
                  class="col-lg-4"
                  v-if="formField.type =='text' || formField.type =='textarea' || formField.type =='number'"
                >
                  <div class="input-material">
                    <input
                      v-model="formField.min_length"
                      v-validate="'required|numeric'"
                      placeholder="Minimum Length"
                      name="min_length"
                      id="min_length"
                      type="text"
                    />
                    <label>Minimum Length</label>
                  </div>
                  <p class="error_message">
                    <span
                      v-if="submitted && errors.has('min_length')"
                    >{{ errors.first(`${'min_length'}`) }}</span>
                  </p>
                </div>

                <div
                  class="col-lg-4"
                  v-if="formField.type =='text' || formField.type =='textarea' || formField.type =='number'"
                >
                  <div class="input-material">
                    <input
                      v-model="formField.max_length"
                      v-validate="'required|numeric'"
                      placeholder="."
                      name="max_length"
                      id="max_length"
                      type="text"
                    />
                    <label>Maximum Length</label>
                  </div>
                  <p class="error_message">
                    <span
                      v-if="submitted && errors.has('max_length')"
                    >{{ errors.first(`${'max_length'}`) }}</span>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-1 px-0 d-flex justify-content-center align-items-center border-left">
              <button
                v-if="formFieldIndex === 0"
                @click.prevent.stop="increaseformField()"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button
                v-else
                @click.prevent.stop="decreaseformField(formFieldIndex)"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-0">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit(true)"
          >{{ $t('save') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="feedback-forms"
          >{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      form_description: "",
      form_is_active: true,
      btenable: false,
      // v-validate="'required|email'"
      submitted: false,
      fieldvalue: "",
      formFieldList: [
        {
          fieldvalue: "",
          type: "",
          min_length: null,
          max_length: null,
          priority: "Compulsary",
        },
      ],
    };
  },
  mounted() {
    // console.log("Gender :", Gender);
    // this.resetHandler();
  },
  methods: {
    onFocusHandler: function () {
      // this.submitted = false;
    },
    increaseformField: function () {
      this.formFieldList.push({
        fieldvalue: "",
        type: "",
        min_length: null,
        max_length: null,
        priority: "Compulsary",
      });
    },
    decreaseformField: function (index) {
      this.formFieldList.splice(index, 1);
    },
    // resetHandler: function() {
    //   this.Gender.map(x => {
    //     if (x.type === "text" || x.type === "date") {
    //       x.fieldvalue = "";
    //     } else if (x.type === "radio") {
    //       x.fieldvalue = true;
    //     }
    //   });
    // },
    TypeValidation: function () {
      let count = 0;

      this.formFieldList.map((x) => {
        if (x.type.length == 0) {
          count++;
        }
      });

      if (count > 0) {
        return true;
      } else {
        return false;
      }
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;

      this.$validator.validate().then((valid) => {
        console.log("Valid :", valid);

        if (this.TypeValidation()) {
          return;
        }
        if (valid) {
          this.btenable = true;
          let payload = {
            formName: this.fieldvalue,
            formFieldList: this.formFieldList,
            is_active: this.form_is_active,
          };
          console.log("payload :", payload);

          MasterService.AddFeedbackForm(payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                // this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/Cinema-manager/feedback-forms",
                  });
                }
                this.submitted = false;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    },
  },
};
</script>
<style>

.new-border{
  border: 2px solid #b1b4b8;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/FeedbackFormComponents/addForm.vue